module.exports = {
	ASSET		: 1,
	LIABILITY   : 2,
    EQUITY      : 3,
    REVENUE     : 4,
    EXPENSE     : [5,6,7,8],
};